import { normalizeUmlauts } from "@modules/util/normalize-umlauts"
import { getQueryParameter } from "@modules/util/query-parameter"
import { getLocation } from "../location/location"
import { getCategories } from "./category"
import { getFilters } from "./filter"
import { FILTER_GROUP_NAME_MAP } from "./filter-group-name-map"
import { getSearchText } from "./filter-selection/search-text-data"

const SELECT_DEFAULT_MAX = "300"

type OldFilterData = {
    description?: string
    merkmalGroup: string
    seoGroup?: string
    max?: string
    min?: string
}

type OldFilterCharacteristics = Record<
    string,
    {
        options: Record<string, OldFilterData>
    }
>

type OldFilterOpenings = Record<string, OldFilterData>

export function getAllFilterSegmentsOldFormat() {
    const filters = getFilters()
    const obj = {
        name: "",
        location: {
            // TODO the following four can be left empty for now
            adresse: getLocation().address || "",
            adresseName: getLocation().addressName || "",
            hausNr: "",
            strasse: "",
            // GebietsId and LocationId both cant be set at the same time. Either one is empty or both
            gebietsId: getLocation().regionId || "",
            // LocationId is actually the cityId
            locationId: getLocation().cityId || "",
            locationName: getLocation().name,
            locationType: getLocation().locationType,
            umkreis: getQueryParameter("umkreis") || "",
            plz: getLocation().plz,
            // PostalCodes not used currently for save search
            // plz: getLocation().postalCodes,
        },
        searchText: getSearchText(),
        filter: {
            merkmale: {} as OldFilterCharacteristics,
            openings: {} as OldFilterOpenings,
            rubriken: {} as Record<string, string>,
        },
    }

    // add filters
    for (const group of Object.keys(filters)) {
        for (const value of filters[group]) {
            if (group === "alter" || group === "groesse") {
                const displayGroup = normalizeUmlauts(FILTER_GROUP_NAME_MAP[group].values.ANY.displayGroup)
                obj.filter.merkmale[displayGroup] ??= {
                    options: {},
                }
                obj.filter.merkmale[displayGroup].options.Range = {
                    max: filters[group][1] || SELECT_DEFAULT_MAX,
                    merkmalGroup: FILTER_GROUP_NAME_MAP[group].text,
                    min: filters[group][0],
                }
            } else {
                const merkmalText = FILTER_GROUP_NAME_MAP[group].values[value].merkmal as string
                const displayGroup = normalizeUmlauts(FILTER_GROUP_NAME_MAP[group].values[value].displayGroup)
                if (displayGroup === "Zeiten") {
                    obj.filter.openings[merkmalText] = {
                        description: FILTER_GROUP_NAME_MAP[group].values[value].merkmalDescription || "",
                        merkmalGroup: FILTER_GROUP_NAME_MAP[group].text,
                        seoGroup: FILTER_GROUP_NAME_MAP[group].name,
                    }
                } else {
                    obj.filter.merkmale[displayGroup] ??= {
                        options: {},
                    }
                    obj.filter.merkmale[displayGroup].options[merkmalText] = {
                        description: FILTER_GROUP_NAME_MAP[group].values[value].merkmalDescription || "",
                        merkmalGroup: FILTER_GROUP_NAME_MAP[group].text,
                        seoGroup: FILTER_GROUP_NAME_MAP[group].name,
                    }
                }
            }
        }
    }

    // categories
    for (const category of getCategories()) {
        const text = FILTER_GROUP_NAME_MAP.rubrik.values[category].text
        if (!text) {
            console.warn(`Failed converting category to old format. category: ${category}`)
            continue
        }

        obj.filter.rubriken[text] = text
    }

    return obj
}
